import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Invitation } from '../../stores/reducers/invitations';
import Icon, { ICONS, COLORS } from './icon';
import Avatar from './avatar';
import { InvitedPresenter } from '../app-entry/producer/meeting-modal';

export interface SelectUserProps {
	users: InvitedPresenter[],
	onChange: (users: InvitedPresenter[]) => void;
	selected: InvitedPresenter[];
	disabled?: boolean;
	dropdownPosition?: string;
}

export default function SelectUsers(props: SelectUserProps) {
	const {
		users,
		onChange,
		selected,
		disabled,
		dropdownPosition
	} = props;

	const [open, setOpen] = useState(false);
	const [activeClass, setActiveClass] = useState('closed');
	const [selectAll, setSelectAll] = useState(false);

	useEffect(() => {
		if (selected.length === users.length && !selectAll) setSelectAll(true);
	}, [selected]);

	function animationFinished() {
		if (open && activeClass === 'closed') {
			setOpen(false);
		}
	}

	function close() {
		setActiveClass('closed');
	}

	function _open() {
		setOpen(true);
		setTimeout(() => setActiveClass('open'), 16);
	}

	function handleChange(option: InvitedPresenter) {
		setSelectAll(false);
		if (selected.find((selectedUser) => selectedUser.email === option.email)) {
			onChange(selected.filter(opt => opt.email !== option.email));		
		} else {
			if (selected.length + 1 === users.length) {
				toggleSelectAll()
			} else {
				onChange([...selected, option]);
			}
		}
	}

	function toggleSelectAll() {
		if (selectAll) {
			onChange([]);
			setSelectAll(false);
		} else {
			onChange(users)
			setSelectAll(true);
		}
	}

	function selectedUserNameOrEmail(user: InvitedPresenter) {
		if (user.first_name) {
			if (user.last_name) {
				return `${user.first_name} ${user.last_name}`;
			}
			return user.first_name
		} else {
			return user.email
		}
	}

	useEffect(() => {
		const selectUsersElement = document.getElementsByClassName('select-users')[0];

		function closeDropdownIfClickOutside(event: any) {
			var isClickInside = selectUsersElement.contains(event.target);

			if (!isClickInside) {
				// User clicked outside select users dropdown, close it 
				close();
			}
		}

		document.addEventListener('click', closeDropdownIfClickOutside);
		return () => document.removeEventListener("click", closeDropdownIfClickOutside);
	}, [])

	return (
		<div className={classNames("select-users", { open: open, disabled: disabled }, 'margin-bottom-large')}>
			<div className="select-users-label" onClick={_open}>
				<div className="selected-users">
					{selectAll ? (
						<span>All</span>
					) : (
						selected.length > 0 && selected.map((user, index) => <span key={index}>{selectedUserNameOrEmail(user)}</span>)
					)}
				</div>
				<div className="open-users">
					<Icon name={open ? ICONS.KEYBOARD_ARROW_UP : ICONS.KEYBOARD_ARROW_DOWN} color={COLORS.DEFAULT_GRAY} size={10} />
				</div>
			</div>
			<div className="select-background" onClick={close}></div>
			<div onClick={_open} className={classNames("select-users-body", activeClass, dropdownPosition)} style={{ top: `56px` }} onTransitionEnd={animationFinished}>
				<div
					onClick={toggleSelectAll}
					className={classNames("select-users-option checkbox", { selected: selectAll })}>
					<div className="checkbox-outer">
						<FontAwesomeIcon
							icon={faCheck} />
					</div>
					<label>All</label>
				</div>
				{users.map((user, index) => (
					<div
						key={index}
						onClick={() => { handleChange(user) }}
						className={classNames("select-users-option checkbox", { selected: selected.find((selectedUser) => selectedUser.email === user.email)})}>
						<div className="checkbox-outer">
							<FontAwesomeIcon
								icon={faCheck} />
						</div>
						<div className="user-meta">
							<Avatar
								noBorder={true}
								user={user}
								size={'thirtytwo'}
							/>
							<div className="user-name">
								{(user.first_name || user.last_name) &&
									<label>{user.first_name} {user.last_name}</label>
								}
							</div>
							<div className="user-email">
								<span>{user.email}</span>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}
